import { createAction } from '@reduxjs/toolkit';
//import { ErrorObject } from '../StoreConstants';
//import { UserPropType } from './InitialState';

const Types = {
  OpenMenu: 'OPEN_MENU',
  CloseMenu: 'CLOSE_MENU',
}

const Creators = {
  openMenu: createAction(Types.OpenMenu),
  closeMenu: createAction(Types.CloseMenu),
}

export { Types };
export default Creators;